/* eslint-disable global-require */
const teamList = [
  {
    id: 0,
    fname: "Sarah",
    lname: "Bell",
    position: "Yoga Instructor",
    img: require("../../images/Team/team-sarah.jpg.webp"),
  },
  {
    id: 1,
    fname: "ALEXANDER",
    lname: "NEIL",
    position: "Bodybuilding coach",
    img: require("../../images/Team/team-alexander.jpg.webp"),
  },
  {
    id: 2,
    fname: "LEA",
    lname: "PAULSON",
    position: "Yoga Instructor",
    img: require("../../images/Team/team-lea.jpg.webp"),
  },
  {
    id: 3,
    fname: "ROSE",
    lname: "TURNER",
    position: "Aerobic instructor",
    img: require("../../images/Team/team-alexander.jpg.webp"),
  },
  {
    id: 4,
    fname: "CAROL",
    lname: "MCLEAN",
    position: "Pilates instructor",
    img: require("../../images/Team/team-carol.jpg.webp"),
  },
  {
    id: 5,
    fname: "SIMON",
    lname: "REES",
    position: " Fitness coach",
    img: require("../../images/Team/team-simon.jpg.webp"),
  },
];

export default teamList;
